import React from 'react';
import styled, { css } from 'styled-components';
import ReactTooltip from 'react-tooltip';

import { palette, breakpoints } from '../../constants/styles';
import Title from './Title';
import Text from './Text';
import { FinancialAdvisorsInfo } from '../landing/Conocenos';
import CTAButton from './CTAButton';
import Icon from './Icon';

const FinancialAdvisorImage = styled.img`
  width: 100%;
  margin-right: 10px;
  max-width: 140px;
  min-height: 162px;

  ${breakpoints.tablet} {
    width: 80%;
  }
`;

const FinancialAdvisorName = css`
  margin-right: 0px;
  margin-top: 0.5rem;
  min-width: 140px;

  ${breakpoints.tablet} {
    min-width: 160px;
  }
`;

const FinancialAdvisorResultsDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${breakpoints.mobileLandscape} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 45%;
  }

  ${({ cta }) =>
    cta &&
    css`
      height: fit-content;
      justify-self: center !important;
      align-self: center !important;
      display: flex;
      flex-direction: column;
    `}
`;

const FinancialAdvisorResults = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 700px;
  background-color: white;

  ${FinancialAdvisorResultsDescriptionContainer}:nth-child(2) {
    flex-direction: row-reverse;

    ${breakpoints.mobileLandscape} {
      flex-direction: column;
    }
  }

  ${breakpoints.mobileLandscape} {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    max-width: 500px;
  }

  ${({ metas }) =>
    metas &&
    css`
      ${breakpoints.mobileLandscape} {
        max-width: none;
      }
    `}
`;

const FinancialAdvisorResultsImage = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: center;
  align-items: center;

  max-width: 200px;

  ${breakpoints.mobileLandscape} {
    width: 100%;
  }
`;

const FinancialAdvisorResultsDescription = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  width: 50%;
  margin-top: -15px;
  align-self: center;
  min-height: 85px;

  ${breakpoints.mobileLandscape} {
    min-height: 60px;
    width: 85%;
    margin-left: 30px;
    margin-left: 0px;
    margin-top: 5px;
  }

  ${breakpoints.tablet} {
    margin-top: 10px;
  }

  ${({ alternative }) =>
    alternative &&
    css`
      margin-right: 20px;
      margin-left: 0px;

      ${breakpoints.mobileLandscape} {
        text-align: left;
        margin-left: 0px;
        margin-right: 0px;
      }
    `}
`;

const StyledSpace = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: center;
  height: 35px;
  ${breakpoints.mobileLandscape} {
    height: 20px;
  }
`;

const StyledText = css`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-items: flex-start;
  height: 35px;
  margin-top: 5px;
  ${breakpoints.mobileLandscape} {
    height: 20px;
  }
`;

const StyledTextContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-items: flex-start;
  height: 35px;

  ${breakpoints.mobileLandscape} {
    height: 20px;
  }
`;

const FinancialAdvisors = (
  message,
  metric,
  maxw,
  linkStyles = css`
    width: 100%;
    margin-top: 1rem;
  `,
) => (
  <FinancialAdvisorResults style={{ maxWidth: maxw }}>
    <ReactTooltip className="styled-tooltip" />
    {FinancialAdvisorsInfo.map(
      (FA, i) =>
        (i === 1 || i === 0) && (
          <FinancialAdvisorResultsDescriptionContainer key={`${FA.name}`}>
            <FinancialAdvisorResultsImage>
              <FinancialAdvisorImage src={FA.imageLink} />
              <Title level={5} styles={FinancialAdvisorName} align="center">
                {FA.name}
              </Title>
            </FinancialAdvisorResultsImage>
            <FinancialAdvisorResultsDescription>
              <StyledSpace>
                <Icon icon="education" size={20} color={palette.primaryColor} />
              </StyledSpace>
              <Text styles={StyledText} type="caption">
                {FA.education}
              </Text>
              <StyledSpace>
                <Icon icon="badge" size={20} color={palette.primaryColor} />
              </StyledSpace>
              <StyledTextContainer>
                {FA.credentials.map((credential, j) =>
                  j !== FA.credentials.length - 1 ? (
                    <Text
                      key={`${FA.name}-${credential.name}`}
                      type="credentialSmall"
                      tip={credential.description}
                    >
                      {credential.name},
                    </Text>
                  ) : (
                    <Text
                      key={`${FA.name}-${credential.name}`}
                      type="credentialSmall"
                      tip={credential.description}
                    >
                      {credential.name}
                    </Text>
                  ),
                )}
              </StyledTextContainer>
            </FinancialAdvisorResultsDescription>
          </FinancialAdvisorResultsDescriptionContainer>
        ),
    )}
    <FinancialAdvisorResultsDescriptionContainer cta>
      <CTAButton icon="message" linkStyles={linkStyles} message={message} event={metric} />
    </FinancialAdvisorResultsDescriptionContainer>
  </FinancialAdvisorResults>
);

export default FinancialAdvisors;
